import { Extension } from "@tiptap/core"
import { Plugin } from "@tiptap/pm/state"

// After Shift+Enter inserts a hard break at the end of a block, the browser
// snaps the DOM caret before the trailing <br>, so the next keystroke lands on
// the previous line. Only when the mismatch is exactly that hard-break
// boundary, insert at the editor's own selection instead.
export const HardBreakCaretFix = Extension.create({
	name: "hardBreakCaretFix",
	addProseMirrorPlugins() {
		return [
			new Plugin({
				props: {
					handleTextInput(view, from, _to, text) {
						const { selection } = view.state
						if (!selection.empty || from !== selection.from - 1) return false
						if (view.state.doc.nodeAt(from)?.type.name !== "hardBreak") {
							return false
						}
						view.dispatch(
							view.state.tr.insertText(text, selection.from, selection.from),
						)
						return true
					},
				},
			}),
		]
	},
})
